import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function Pharmaceutical() {
  return <DetailPage data={detailPages.pharmaceutical} />;
}
